<template>
    <div class="settings">
        <div class="container section">
            <div class="row">
                <div class="col-lg-3">
                    <div class="settings-menu">
                        
                        <div class="menu-item" :class="{'selected': selected === 'general'}" @click="selected = 'general'">
                            <i class="fas fa-fw fa-cogs" />
                            &nbsp;
                            Generelt
                        </div>

                        <div class="menu-item" :class="{'selected': selected === 'accountPlan'}" @click="selected = 'accountPlan'">
                            <i class="fas fa-fw fa-list" />
                            &nbsp;
                            Kontoplan
                        </div>

                        <!--<div class="menu-item" :class="{'selected': selected === 'budget'}" @click="selected = 'budget'">
                            <i class="fas fa-fw fa-calculator" />
                            &nbsp;
                            Budget
                        </div>-->

                        <div class="menu-item" :class="{'selected': selected === 'valuechainCalculation'}" @click="selected = 'valuechainCalculation'" v-if="$auth.user().company.api_provider.slug === 'minuba'">
                            <i class="fas fa-fw fa-calculator" />
                            &nbsp;
                            Værdikæde kalkulation
                        </div>

                        <div class="menu-item" :class="{'selected': selected === 'employees'}" @click="selected = 'employees'">
                            <i class="fas fa-fw fa-users" />
                            &nbsp;
                            Medarbejdere
                        </div>

                        <div class="menu-item" :class="{'selected': selected === 'projectStatuses'}" @click="selected = 'projectStatuses'">
                            <i class="fas fa-fw fa-briefcase" />
                            &nbsp;
                            Opgavestatus
                        </div>

                        <div class="menu-item" :class="{'selected': selected === 'excludeProjects'}" @click="selected = 'excludeProjects'">
                            <i class="fas fa-fw fa-times" />
                            &nbsp;
                            Skjul opgaver
                        </div>

                        <div class="menu-item" :class="{'selected': selected === 'timeloggingTypes'}" @click="selected = 'timeloggingTypes'">
                            <i class="fas fa-fw fa-clock" />
                            &nbsp;
                            Tidsregistreringstyper
                        </div>

                        <div class="divider"></div>

                        <div class="menu-item" :class="{'selected': selected === 'users'}" @click="selected = 'users'" v-if="['admin', 'super-admin'].includes($auth.user().roles[0].name)">
                            <i class="fas fa-fw fa-users" />
                            &nbsp;
                            Systembrugere
                        </div>

                        <div class="menu-item" :class="{'selected': selected === 'user'}" @click="selected = 'user'">
                            <i class="fas fa-fw fa-user" />
                            &nbsp;
                            Din profil
                        </div>

                        <div class="divider"></div>

                        <div style="font-weight:bold;margin-bottom:30px;font-family:'Montserrat';">
                            Justering af information på opgaverne
                        </div>

                        <div v-if="$store.state.config.availableDepartments.length > 2" class="menu-item" :class="{'selected': selected === 'cleanup'}" @click="selected = 'cleanup'">
                            <i class="fas fa-fw fa-broom" />
                            &nbsp;
                            Opgaver uden afdeling
                        </div>
                        
                        <div class="menu-item" :class="{'selected': selected === 'projectsMissingBudget'}" @click="selected = 'projectsMissingBudget'" v-if="$auth.user().company.api_provider.slug === 'minuba'">
                            <i class="fas fa-fw fa-divide" />
                            &nbsp;
                            Opgaver uden budget
                        </div>

                        <!--<div
                            class="menu-item"
                            v-for="item in menuitems"
                            :key="item.name"
                            :class="{'selected': selected === item.slug}"
                            @click="selected = item.slug"
                            v-if="item.slug === 'cleanup' && $store.state.config.availableDepartments.length > 1 || item.slug !== 'cleanup'"
                        >
                            <div class="divider" v-if="item.slug === 'users'" />
                            <div class="divider" v-if="item.slug === 'projectsMissingBudget'" />
                            <div v-if="item.slug === 'projectsMissingBudget'" style="margin-bottom:15px;">Justering af information på opgaverne</div>
                            <i :class="'fas fa-fw fa-' + item.icon" />
                            &nbsp;
                            {{ item.name }}
                        </div>-->

                    </div>
                </div>
                <div class="col-lg-9">
                    <accountPlan v-if="selected === 'accountPlan'" />
                    <employees v-if="selected === 'employees'" />
                    <general v-if="selected === 'general'" />
                    <projectStatuses v-if="selected === 'projectStatuses'" />
                    <cleanup v-if="selected === 'cleanup'" />
                    <users v-if="selected === 'users'" />
                    <user v-if="selected === 'user'" />
                    <budget v-if="selected === 'budget'" />
                    <valuechain-calculation v-if="selected === 'valuechainCalculation'" />
                    <exclude-projects v-if="selected === 'excludeProjects'" />
                    <projects-missing-budget v-if="selected === 'projectsMissingBudget'" />
                    <timelogging-types-settings v-if="selected === 'timeloggingTypes'" />
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "../../styles/vars.scss";

    .settings-menu {

        .menu-item {
            cursor: pointer;
            transition: margin 0.3s ease;

            &:hover {
                margin-left: $margin--small / 2;
            }

            &:not(:last-of-type) {
                margin-bottom: $margin--small;
            }

            &.selected {
                font-weight: bold;
            }
        }
    }

</style>

<script>
export default {
    data () {
        return {
            selected: 'general',
            menuitems: [
                { name: 'Generelt', slug: 'general', icon: 'cogs' },
                { name: 'Kontoplan', slug: 'accountPlan', icon: 'list' },
                { name: 'Budget', slug: 'budget', icon: 'calculator' },
                { name: 'Medarbejdere', slug: 'employees', icon: 'users' },
                { name: 'Opgavestatus', slug: 'projectStatuses', icon: 'briefcase' },
                { name: 'Skjul opgaver', slug: 'excludeProjects', icon: 'times' },
                { name: 'Tidsregistreringstyper', slug: 'timeloggingTypes', icon: 'clock' },
                { name: 'Systembrugere', slug: 'users', icon: 'users' },
                { name: 'Din profil', slug: 'user', icon: 'user' },
                { name: 'Opgaver uden budget', slug: 'projectsMissingBudget', icon: 'divide' }
            ]
        }
    },
    components: {
        'accountPlan': require('./components/accountPlan.vue'),
        'budget': require('./components/budget.vue'),
        'valuechain-calculation': require('./components/valuechainCalculation.vue'),
        'employees': require('./components/employees.vue'),
        'general': require('./components/general.vue'),
        'cleanup': require('./components/cleanup.vue'),
        'projectStatuses': require('./components/projectStatuses.vue'),
        'users': require('./components/users.vue'),
        'user': require('./components/user.vue'),
        'exclude-projects': require('./components/excludeProjects.vue'),
        'projects-missing-budget': require('./components/projectsMissingBudget.vue'),
        'timelogging-types-settings': require('./components/timeloggingTypesSettings.vue')
    },
    mounted () {
        if (this.$route.params.selected) {
            this.selected = this.$route.params.selected
        }
        if (this.$store.state.config.availableDepartments.length > 2) {
            this.menuitems.push({
                name: 'Uden afdeling (oprydning)',
                slug: 'cleanup',
                icon: 'broom'
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// index.vue?f387b304